import { render, staticRenderFns } from "./cart-navbar-product-list-item.vue?vue&type=template&id=afa7fe76&"
import script from "./cart-navbar-product-list-item.vue.ts?vue&type=script&lang=ts&"
export * from "./cart-navbar-product-list-item.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports